export const commonStyle={


    
          sx:{
            "::-webkit-scrollbar": {
              width: "6px",
            },
            "::-webkit-scrollbar-thumb": {
              background: "#A0AEC0",
              borderRadius: "24px",
            },
            "::-webkit-scrollbar-track": {
              background: "transparent",
            },
            scrollbarWidth: "thin",
            scrollbarColor: "#A0AEC0 transparent",
          }
        
}